import { getInitialCurrentRowWidth } from './getInitialCurrentRowWidth';
import { getFullTagWidth } from './getFullTagWidth';
/**
 * @description Функция считает, какое количество тегов можно вместить в заданную ширину
 * контейнера тегов. Она учитывает ширину кнопки "Ещё Х"/"Скрыть" и ограничение на количество строк.
 */
export function calculateNumberOfTags(_ref) {
  let {
    isFolded,
    tagsOptions,
    maxLines,
    availableWidth,
    moreButtonWidth,
    lessButtonWidth,
    leftAdornmentWidth,
    rightAdornmentWidth,
    tagsWidthsMap
  } = _ref;
  let currentRowIndex = 1;
  let currentRowWidth = 0;
  let numberOfTags = 0;
  let isTagsFitMaxLines = true;
  for (let tagIndex = 0; tagIndex < tagsOptions.length; tagIndex += 1) {
    if (currentRowIndex > maxLines) {
      numberOfTags = isFolded ? numberOfTags : tagsOptions.length;
      isTagsFitMaxLines = false;
      break;
    }
    const cloudControlButtonWidth = isFolded ? moreButtonWidth : lessButtonWidth;

    // Считаем очередную ширину строки, в которую будем рендерить теги. Там уже может быть контент
    currentRowWidth = getInitialCurrentRowWidth(currentRowWidth, cloudControlButtonWidth, leftAdornmentWidth, rightAdornmentWidth, currentRowIndex, maxLines);
    const fullTagWidth = getFullTagWidth(tagsOptions, tagIndex, tagsWidthsMap);

    // В строке нет тегов, и текущий тег не помещается в строку
    if (currentRowWidth === 0 && fullTagWidth >= availableWidth) {
      numberOfTags += 1;
      currentRowIndex += 1;
      currentRowWidth = 0;
      continue;
    }
    currentRowWidth += fullTagWidth;

    // Текущий тег помещается в строку
    if (currentRowWidth < availableWidth) {
      numberOfTags += 1;
      continue;
    }

    // Текущий тег равен ширине строки
    if (currentRowWidth === availableWidth) {
      numberOfTags += 1;
      currentRowIndex += 1;
      currentRowWidth = 0;
      continue;
    }

    // В строке уже есть теги, и текущий тег не помещается в строку
    if (currentRowWidth > availableWidth) {
      currentRowIndex += 1;
      currentRowWidth = 0;
      tagIndex -= 1;
      continue;
    }
  }
  return {
    numberOfTags: isFolded ? numberOfTags : tagsOptions.length,
    isTagsFitMaxLines
  };
}